import { useEffect, useState } from 'react';
import ProductImage from './ProductImage';

/**
 * Galería de la ficha de producto.
 *
 * Hoy la mayoría de productos tiene una sola foto, así que con una imagen no
 * se pintan miniaturas. Se acepta una lista para no tener que reescribir esto
 * cuando haya varias por producto.
 */
export default function ProductGallery({ imagenes = [], alt, agotado = false }) {
  const fotos = imagenes.filter(Boolean);
  const [activa, setActiva] = useState(0);
  const [fallida, setFallida] = useState(false);

  // Al cambiar de producto hay que volver a la primera foto; si no, se queda
  // seleccionado un índice que puede no existir en el producto nuevo.
  useEffect(() => {
    setActiva(0);
    setFallida(false);
  }, [imagenes.join('|')]);

  if (fotos.length === 0 || fallida) {
    return (
      <div className="df-card w-full aspect-square flex items-center justify-center text-df-muted">
        <span className="text-sm">Sin imagen disponible</span>
      </div>
    );
  }

  return (
    <div>
      <ProductImage
        src={fotos[activa]}
        alt={alt}
        agotado={agotado}
        loading="eager"
        onError={() => setFallida(true)}
        className="aspect-square w-full p-4 rounded-xl border border-df-border"
      />

      {fotos.length > 1 && (
        <div className="mt-3 flex gap-2 flex-wrap">
          {fotos.map((foto, i) => (
            <button
              key={foto}
              type="button"
              onClick={() => setActiva(i)}
              aria-label={`Ver imagen ${i + 1} de ${fotos.length}`}
              aria-current={i === activa}
              className={`w-16 h-16 rounded-lg border p-1 bg-white transition-colors ${
                i === activa ? 'border-df-accent' : 'border-df-border hover:border-df-accent/50'
              }`}
            >
              <ProductImage src={foto} alt="" className="w-full h-full rounded" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
